import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowUp",
  "use": "ArrowUp-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol viewBox=\"0 0 20 12\" id=\"ArrowUp\"><path d=\"M3.354 12L10 5.544 16.646 12 19.5 9.228 10 0 .5 9.228z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol